import React from 'react';
import {
  GENERATION_STATUS_COMPACT_LABELS,
  GENERATION_STATUS_LABELS,
  SCHEDULE_STATUS_COMPACT_LABELS,
  SCHEDULE_STATUS_LABELS,
} from '../constants';

const STATUS_STYLES = {
  pending: 'bg-amber-50 text-amber-800 border-amber-200',
  awaiting_window: 'bg-sky-50 text-sky-800 border-sky-200',
  sent: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  failed: 'bg-red-50 text-red-700 border-red-200',
  cancelled: 'bg-slate-100 text-slate-600 border-slate-200',
  generating: 'bg-blue-50 text-blue-700 border-blue-200',
  ready: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

function Badge({ status, labels, compact = false, title }) {
  const label = labels[status] || status;
  const style = STATUS_STYLES[status] || 'bg-slate-100 text-slate-600 border-slate-200';

  return (
    <span
      className={`inline-flex items-center rounded-md font-medium border whitespace-nowrap px-2 py-0.5 ${
        compact ? 'text-[11px]' : 'text-xs'
      } ${style}`}
      title={title}
    >
      {label}
    </span>
  );
}

export function ScheduleStatusBadge({ status, compact = false, title }) {
  const labels = compact ? SCHEDULE_STATUS_COMPACT_LABELS : SCHEDULE_STATUS_LABELS;
  const fullLabel = SCHEDULE_STATUS_LABELS[status] || status;
  return (
    <Badge
      status={status}
      labels={labels}
      compact={compact}
      title={title || (compact ? fullLabel : undefined)}
    />
  );
}

export function GenerationStatusBadge({ status, compact = false, title }) {
  const labels = compact ? GENERATION_STATUS_COMPACT_LABELS : GENERATION_STATUS_LABELS;
  const fullLabel = GENERATION_STATUS_LABELS[status] || status;
  return (
    <Badge
      status={status}
      labels={labels}
      compact={compact}
      title={title || (compact ? fullLabel : undefined)}
    />
  );
}
